// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"30":"539823ae","460":"f1647098","807":"931b64ce"}[chunkId] + ".js";
};